import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 30px;
  left: -382px;
  background-color: ${(props) => props.theme.colors.cardSettingsBackgroundcolor};
  border: 0.5px solid ${(props) => props.theme.colors.diviserSmoothColor};
  border-radius: 10px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.05);
  min-width: 462px;
  max-width: 800px;
  z-index: 4;

  .header {
    color: ${(props) => props.theme.colors.cardSettingsTextColor};
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
    h3 {
      font-weight: normal;
    }
  }

  .settings-item {
    padding: 10px 20px;
    border-top: 1px solid ${(props) => props.theme.colors.diviserSmoothColor};
    height: 60px;
    &:hover {
      background: rgba(108, 108, 108, 0.1);
    }
  }

  .settings-closer {
    cursor: pointer;
    display: none;
  }

  /**
   * customizing selector
   */
  .seletor-wrapper {
    background: ${(props) => props.theme.colors.cardSettingsSeletorBackgroundColor};
    border: 1px solid ${(props) => (!props.withData ? props.theme.colors.disabledMeatballItem : props.theme.colors.cardSettingsSeletorBodyBorderColor)};
    color: #610082 !important;
    max-width: 148px;
    .seletor-head {
      background-color: transparent;
      height: 30px; //50% da altura da área do parente
      .title {
        color: ${(props) => (!props.withData ? props.theme.colors.disabledMeatballItem : props.theme.colors.cardSettingsTitleColor)} !important;
      }
    }
    .seletor-body {
      background: ${(props) => props.theme.colors.cardSettingsSeletorBackgroundColor};
      border-right: 1px solid ${(props) => props.theme.colors.cardSettingsSeletorBodyBorderColor} !important;
      border-left: 1px solid ${(props) => props.theme.colors.cardSettingsSeletorBodyBorderColor} !important;
      border-bottom: 1px solid ${(props) => props.theme.colors.cardSettingsSeletorBodyBorderColor} !important;
      .option-label {
        color: #610082 !important;
      }
    }
  }

  @media (max-width: 530px) {
    position: fixed;
    left: 0;
    top: 0;
    min-width: auto;
    width: 100vw;
    height: 100vh;
    z-index: 9999;

    .settings-closer {
      font-size: 2.6rem;
      font-weight: bold;
      display: block;
    }
  }
`;
